import { VStack } from "@gluestack-ui/themed";
import { StatusBar } from "@repo/core/components/layout/StatusBar";

import { VerifyInformationsController } from "./controller";
import { Button } from "@repo/core/components/core/Button";
import { ActionSheet } from "@repo/core/components/layout/Actionsheet";
import { Text } from "@gluestack-ui/themed";
/* import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { AlertModalVariant } from "@repo/core/components/layout/ModalTemplate/AlertModal/types"; */
import { Icon } from "@repo/core/components/core/Icon";
import { IconNames } from "@repo/core/components/core/Icon/types";
import { ProposalOptionsItem } from "@repo/core/screens/Proposals/screens/ProposalsSearch/components/ProposalOptionsSheet/ProposalOptionsItem";
import { FEATURE_FLAGS } from "@repo/core/constants/featureFlags";
import { PROPOSAL_ACTIONS } from "@repo/core/constants/proposals";
import Spinner from "@repo/core/components/core/Spinner";
import { ValidationStep } from "./utils";

export const VerifyInformations = () => {
  const {
    actionSheetRef,
    /*     alertOptions,
    alertModalRef, */
    isTabletOrWeb,
    handleCloseOptions,
    validationInfo,
    status,
    isShowOptions,
    buttonActions,
    handleViewProposal
  } = VerifyInformationsController();

  return (
    <>
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <VStack flex={1} alignItems="center" p="$4" bg={validationInfo.bgColor}>
        <VStack
          flex={1}
          pt="$16"
          gap="$8"
          w={isTabletOrWeb ? 480 : "$full"}
          m={isTabletOrWeb ? "auto" : undefined}
        >
          {status === ValidationStep.AWAITING ? (
            <VStack
              flex={1}
              alignItems="center"
              justifyContent="center"
              gap="$4"
            >
              <Spinner />
              <Text
                textAlign="center"
                fontSize="$md"
                fontWeight={600}
                color="$textLight900"
              >
                Analisando proposta
              </Text>
            </VStack>
          ) : (
            <VStack gap="$6" alignItems="center" justifyContent="center">
              <VStack gap="$4" alignItems="center" justifyContent="center">
                <Icon
                  name={validationInfo.icon as IconNames}
                  size={56}
                  color={validationInfo.iconColor}
                />
                <Text
                  textAlign="center"
                  fontSize="$lg"
                  fontWeight={600}
                  color="$textLight900"
                >
                  {validationInfo.title}
                </Text>
              </VStack>
              <Text
                textAlign="center"
                fontSize="$sm"
                fontWeight={400}
                color="$textLight900"
              >
                {validationInfo.subtitle}
              </Text>
            </VStack>
          )}
        </VStack>
        {isShowOptions ? (
          <VStack gap="$4" mb="$4" w={isTabletOrWeb ? 480 : "$full"}>
            {validationInfo?.showPrimaryButton ? (
              <Button
                size="xl"
                action="primary"
                text={buttonActions.primary?.label || ""}
                w="$full"
                onPress={buttonActions.primary.onPress}
              />
            ) : null}
            {validationInfo?.showSecondaryButton ? (
              <Button
                variant="outline"
                action="secondary"
                size="xl"
                leftIcon={{
                  name: (buttonActions.secondary?.icon ||
                    "ellipsis-vertical") as IconNames,
                  size: 18
                }}
                w="$full"
                text={buttonActions.secondary?.label || ""}
                onPress={buttonActions.secondary?.onPress}
              />
            ) : null}
            <Button
              variant="outline"
              action="darker-secondary"
              size="xl"
              leftIcon={{
                name: "eye",
                size: 18,
                color: "$secondary900"
              }}
              w="$full"
              bg="$white"
              borderColor="$secondary900"
              $hover-backgroundColor="$secondary50"
              $pressed-backgroundColor="$secondary100"
              text="Ver proposta"
              textStyle={{ fontWeight: 600 }}
              onPress={handleViewProposal}
            />
          </VStack>
        ) : null}
      </VStack>
      <ActionSheet ref={actionSheetRef}>
        <VStack w="$full" p="$2" mb="$2">
          <VStack mb="$4" px="$3">
            <Text fontSize="$md" fontWeight={500} color="$textLight600">
              Selecione uma das opções abaixo:
            </Text>
          </VStack>
          <VStack>
            {/* TODO: Implement options */}
            {FEATURE_FLAGS.enableCreditTable ? (
              <ProposalOptionsItem
                action={PROPOSAL_ACTIONS.SEND_TO_CREDIT_TABLE}
                label="Enviar para mesa de crédito"
                icon="hand-holding-dollar"
                onPress={() => null}
              />
            ) : null}
            <ProposalOptionsItem
              action={PROPOSAL_ACTIONS.EDIT_PROPOSAL}
              label="Editar proposta"
              icon="verified"
              onPress={() => null}
            />
          </VStack>

          <VStack w="$full" p="$3">
            <Button
              action="primary"
              text="Continuar"
              onPress={handleCloseOptions}
            />
          </VStack>
        </VStack>
      </ActionSheet>
      {/*  <AlertModal
        ref={alertModalRef}
        title="Informações coletadas"
        variant={AlertModalVariant.success}
        options={alertOptions}
      >
        <Text color="$textLight900" fontWeight={400} size={"sm"}>
          Você coletou os dados de segurança, a biometria e a documentação do
          cliente com sucesso. Agora faremos a validação dessas informações.
          Toque para{" "}
          <Text color="$textLight900" fontWeight={600} size={"sm"}>
            Continuar
          </Text>
        </Text>
      </AlertModal> */}
    </>
  );
};
